import { render, staticRenderFns } from "./KidOrderDetail.vue?vue&type=template&id=3c79b23b&scoped=true&"
import script from "./KidOrderDetail.vue?vue&type=script&lang=js&"
export * from "./KidOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./KidOrderDetail.vue?vue&type=style&index=0&id=3c79b23b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c79b23b",
  null
  
)

export default component.exports